"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _clsx = _interopRequireDefault(require("clsx"));

var _ProductDetailAddToCartButton = _interopRequireDefault(require("@sprinx/react-com/ProductDetailAddToCartButton"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _useRedirect = _interopRequireDefault(require("@sprinx/react-routes/useRedirect"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _buttonContainer;

  return {
    root: {
      fontSize: 16,
      fontWeight: 400,
      '&:hover': {
        backgroundColor: theme.palette.primary.main
      }
    },
    buyButton: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.secondary.main
      },
      '& .MuiButton-label': {
        whiteSpace: 'nowrap'
      }
    },
    buttonContainer: (_buttonContainer = {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center'
    }, (0, _defineProperty2.default)(_buttonContainer, theme.breakpoints.down('sm'), {
      display: 'flex',
      justifyContent: 'flex-end'
    }), (0, _defineProperty2.default)(_buttonContainer, theme.breakpoints.down('xs'), {
      display: 'flex',
      justifyContent: 'center',
      '& button': {
        width: '100%'
      }
    }), _buttonContainer)
  };
}, {
  name: 'ProductListItemCardAddToCartButton'
});

function ProductListItemCardAddToCartButton(_ref) {
  var available = _ref.available,
      pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      renderToGridArea = _ref.renderToGridArea,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["available", "classes", "className", "product", "renderToGridArea"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var setRedirect = (0, _useRedirect.default)();

  var handleRedirectToDetail = _react.default.useCallback(function () {
    setRedirect("".concat(product.href, "#alternatives"));
  }, [product.href, setRedirect]);

  return available ? /*#__PURE__*/_react.default.createElement(_ProductDetailAddToCartButton.default, (0, _extends2.default)({}, rest, {
    product: product,
    color: "secondary",
    classes: {
      root: (0, _clsx.default)(classes.buttonContainer)
    },
    AddToCartProps: {
      componentProps: {
        ButtonAddToCartProps: {
          noIcon: true,
          // children: t('shoppingCart/buyBtn'),
          classes: {
            root: (0, _clsx.default)(classes.root, classes.buyButton)
          }
        }
      }
    }
  })) : /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, {
    renderToGridArea: renderToGridArea,
    className: classes.buttonContainer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    color: "primary",
    className: classes.root,
    onClick: handleRedirectToDetail
  }, t('shoppingCart/alternatives')));
}

process.env.NODE_ENV !== "production" ? ProductListItemCardAddToCartButton.propTypes = {
  available: _propTypes.default.bool,
  classes: _propTypes.default.shape({
    buttonContainer: _propTypes.default.string,
    buyButton: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    href: _propTypes.default.string
  }).isRequired,
  renderToGridArea: _propTypes.default.string
} : void 0;
ProductListItemCardAddToCartButton.defaultProps = {
  available: false,
  classes: undefined,
  className: undefined,
  renderToGridArea: 'addToCart'
};
var _default = ProductListItemCardAddToCartButton;
exports.default = _default;